import { render, staticRenderFns } from "./IntegerNumeration.vue?vue&type=template&id=ebbbdcb4&"
import script from "./IntegerNumeration.vue?vue&type=script&lang=js&"
export * from "./IntegerNumeration.vue?vue&type=script&lang=js&"
import style0 from "./IntegerNumeration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports